export const PermissionLevel = Object.freeze({
  ADMIN: 'ADMIN',
  HRBP: 'HRBP',
});
